import { render, staticRenderFns } from "./TourProfile.vue?vue&type=template&id=a8454d74&"
import script from "./TourProfile.vue?vue&type=script&lang=js&"
export * from "./TourProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports